import { useState } from "react";

import { DocumentManagementTypes } from "../../utils/constants";
import { USER_ROUTES } from "../../utils/routeConstants";
import DocumentManagementBrowsingList from "../DocumentManagementBrowsingList/DocumentManagementBrowsingList";
import DocumentManagementHeader from "../DocumentManagementHeader/DocumentManagementHeader";
import DocumentManagementSideMenu from "../DocumentManagementSideMenu/DocumentManagementSideMenu";
import { ScreenLayout } from "./DocumentManagementScreenStyles";

function DocumentManagementScreen(props) {
  const { userInfo } = props;
  const [activeMenu, updateActiveMenu] = useState(
    userInfo.profile.name === "Tesorero"
      ? DocumentManagementTypes.CREDIT_AUTH
      : DocumentManagementTypes.SENASA_RESTRICTION
  );
  return (
    <ScreenLayout>
      <DocumentManagementHeader
        title={USER_ROUTES.DOCUMENT_VALIDATION.title.toUpperCase()}
      />
      <DocumentManagementSideMenu
        activeMenu={activeMenu}
        updateActiveMenu={updateActiveMenu}
      />
      <DocumentManagementBrowsingList activeMenu={activeMenu} />
    </ScreenLayout>
  );
}

export default DocumentManagementScreen;
